import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";
import { filterUrls } from "services/api.enums";

export const filterExcelSettlement: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "excelSettlement",
  async (body: any) => {
    // delete body.pageNumber
    const data = await filterTableDataAPI(
      filterUrls.creditSettlement,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      body.pageSize,
      false
    );



    return data.data
  }
);

const initialState: any = {
  settlementData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
  
};

const CreditExcelSettlementSlice = createSlice({
  initialState: initialState,
  name: "excelSettlement",
  reducers: {
    clearCreditSettlement: (state) => {
      state.settlementData = [];
    },
    setFilterCreditSettlement: (state, action) => {
      state.filter = action.payload;
    },

  },
  extraReducers: {
    [filterExcelSettlement.fulfilled as any]: (state, action) => {
      state.settlementData = action.payload;
      state.fetchPost = false;
    },
    [filterExcelSettlement.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterExcelSettlement.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterCreditSettlement, clearCreditSettlement } = CreditExcelSettlementSlice.actions;

export default CreditExcelSettlementSlice.reducer;
